import { render } from "./Diario.vue?vue&type=template&id=dc4b5494&scoped=true&ts=true"
import script from "./Diario.vue?vue&type=script&lang=ts"
export * from "./Diario.vue?vue&type=script&lang=ts"

import "./Diario.vue?vue&type=style&index=0&id=dc4b5494&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4b5494"]])

export default __exports__